<template>
  <div v-if="layerOptions">
    <div
      class="btn-group btn-group-toggle"
      data-toggle="buttons"
    >
      <layer-option
        v-for="(layerOption) in layerOptions"
        :key="`lo${layerOption.id}`"
        :id="layerOption.id"
        :name="layerOption.name"
        :wms-layer="layerOption.wmsLayer"
        :checked="selectedLayerWms === layerOption.wmsLayer"
        :color="layerOption.color"
      />
    </div>
    <div
      class="pt-2 layerDescription"
      v-html="selectedLayerDescription"
    />
  </div>
</template>

<script>
import EventBus from '@/eventBus';

import LayerOption from './LayerOption.vue';

export default {
  components: {
    LayerOption,
  },
  data() {
    return {
      layerOptionsData: this.layerOptions,
      selectedLayerDescription: null,
      selectedLayerWms: null,
    };
  },
  destroyed() {
    EventBus.$off('layer-changed');
  },
  methods: {
    onLayerChanged(wmsLayer) {
      const selectedLayer = this.layerOptions
        .find((lo) => lo.wmsLayer === wmsLayer);
      this.selectedLayerDescription = selectedLayer
        .description;
      this.selectedLayerWms = selectedLayer
        .wmsLayer;
    },
  },
  mounted() {
    EventBus.$on('layer-changed', this.onLayerChanged);
  },
  name: 'LayerSelector',
  props: {
    layerOptions: {
      type: Array,
      required: true,
    },
  },
  watch: {
    layerOptions(newV) {
      this.layerOptionsData = newV;
      if (newV.length === 0) {
        return;
      }
      this.selectedLayerDescription = newV[0].description;
      EventBus.$emit('layer-changed', newV[0].wmsLayer);
    },
  },
};

</script>

<style scoped>
.layerDescription {
  min-height: 70px;
}
</style>
